export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()

  if (userStore.user) {
    return
  }

  // TODO: this is temporary, until we have a proper solution for the user store which shouldn't be store, but a composable,
  // and user should be already fetched on server
  await userStore.fetchUser()
  if (!userStore.user) {
    return customNavigateTo({ name: 'login' })
  }
})
